import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { VerificaTokenService } from './servicos/autenticacao/verifica-token.service';
import { AuthServiceService } from './servicos/autenticacao/auth-service.service';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { CorService } from './servicos/cor/cor.service';
import { AppService } from './servicos/app/app.service';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatListModule, MatNavList } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink, RouterOutlet, AsyncPipe,MatSidenavModule,MatAccordion,MatExpansionModule,MatToolbarModule,MatIcon,MatNavList,MatButtonModule,MatListModule]
})

export class AppComponent implements OnInit {

  readonly version = environment.version;

  constructor(
    private authService: AuthServiceService,
    private verifica: VerificaTokenService,
    private corService: CorService,
    private appService: AppService,
    private titleService: Title,
    private dialog: MatDialog
  ) { }

  logado: BehaviorSubject<boolean>;
  on: Observable<boolean>;
  dir: Observable<boolean>;
  user: BehaviorSubject<any>;
  callcenterOpen = false;
  agentesOpen = false;
  relAgenteOpen = false;

  deslogar() {
    this.authService.deslogar();
  }

  confirmarLogoff(sidenav?: any) {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      width: '360px',
      data: { title: 'Sair', message: 'Deseja realmente encerrar a sessão?' }
    });
    ref.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        sidenav?.close();
        this.deslogar();
      }
    });
  }

  ngOnInit(): void {
    this.authService.usuarioAutenticado();
    this.authService.onlinePermission();
    this.authService.DirPermission();
    this.on = this.authService.accesOn;
    this.dir = this.authService.accesDir;
    this.user = this.authService.infoUser;
    this.logado = this.authService.logado;
    this.corService.pegarThemas();
    this.pegarTitle();
  }

  pegarTitle() {
    this.appService.getInfos().pipe(take(1)).subscribe((resp:any) => {
      this.setTitle(resp?.Titulo)
    })
  }

  setTitle(newTitle:string) {
    this.titleService.setTitle(newTitle)
  }
}
